import { z } from 'zod';

export const ONE_SECOND_IN_MS = 1000;
export const ONE_MINUTE_IN_MS = 60 * ONE_SECOND_IN_MS;
export const ONE_HOUR_IN_MS = 60 * ONE_MINUTE_IN_MS;
export const ONE_DAY_IN_MS = 24 * ONE_HOUR_IN_MS;

export const convertTimeToMinutes = (time: string) => {
  const parsedTime = z.string().time().parse(time);
  const [hours, minutes] = parsedTime.split(':');
  return Number(hours) * 60 + Number(minutes);
};
